export class Client {
  phoneNumber?: string;
  formatedPhoneNumber?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  cardNumber?: number;
}

export class AuthIdModel {
  storeNumber?: string | number;
  clientNumber?: string | number;
  cardholderNumber?: string | number;

  constructor(
    storeNumber?: string | number,
    clientNumber?: string | number,
    cardholderNumber?: string | number
  ) {
    this.storeNumber = storeNumber?.toString();
    this.clientNumber = clientNumber?.toString();
    this.cardholderNumber = cardholderNumber?.toString();
  }
}

export class AuthIdDialogModel extends AuthIdModel {
  loading = false;
}

export class CardNumberResponseModel {
  cardNumber?: string;
}

export class CustomerShortSearchForm {
  email?: string;
  phoneNumber?: string;
}

export class CardholderConfirmationModel {
  authId?: string;
  email?: string;
  emailConfirmed?: boolean;
  phone?: string;
  phoneConfirmed?: boolean;
}

export class UpdateCardVersionRequestModel {
  authId: string;
  cardVersion?: number;
  cardTypeCd?: string;

  constructor(authId: string) {
    this.authId = authId;
  }
}

export class ResetCardholderFieldRequestModel {
  authId: string;
  fieldName: FieldName;

  constructor(authId: string, fieldName: FieldName) {
    this.authId = authId;
    this.fieldName = fieldName;
  }
}

export enum FieldName {
  Email = 1,
  EmailPermission,
  PhoneNumber,
  PhonePermission,
}

export enum AuditHistoryAction {
  reg = "reg",
  cust = "cust",
}
export class AuditHistorySearchModel {
  action: string = AuditHistoryAction.reg;
  dateFrom?: Date;
  dateTo?: Date;
  custNo?: string | number;
  storeNo?: string | number;
}
export class AuditHistoryTestResponse {
  data?: AuditHistoryResponse;
  message?: string;
}
export class AuditHistoryResponse {
  items: AuditHistoryModel[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
  constructor() {
    this.page = 0;
    this.per_page = 0;
    this.pages = 0;
    this.total = 0;
    this.items = [];
  }
}
export class AuditHistoryModel {
  id?: number;
  uniqueKey?: string;
  data?: string;
  date: string | undefined;
  action_by_email: string | undefined;
  user_initiator_email: string | undefined;
  source: string | undefined;
  action: string | undefined;
  store_no: string | undefined;
  cust_no: string | undefined;
  auth_id: string | undefined;
  items: AuditHistoryItem[] | undefined;
}
export class AuditHistoryItem {
  id: string | undefined;
  field_name: string | undefined;
  field_name_display: string | undefined;
  old: string | undefined;
  new: string | undefined;
  address_type_cd: string | undefined;
}

export class RemoveCustomerBlockRequestModel {
  storeKey: string;
  custNo: string;

  constructor(storeKey: string, custNo: string) {
    this.storeKey = storeKey;
    this.custNo = custNo;
  }
}
